<template>
  <rect x="7.5" y="20" width="16" height="5" rx="2.5" fill="#5B5B5B" />
  <rect x="27.5" y="12.5" width="31" height="20" rx="3" fill="#5B5B5B" />
</template>
